import api from 'api'

export type HighnoteErrorCategory =
  | 'HighnoteUserError'
  | 'HighnoteSystemError'
  | 'HighnoteError'

export interface HighnoteErrorCode {
  code: number
  name: string
  category: HighnoteErrorCategory
  description: string
  resolutionPrompt: string
  highnoteUserErrorCode: string | null
}

interface HighnoteErrorCodesPayload {
  items: HighnoteErrorCode[]
}

export const getHighnoteErrorCodes = async (): Promise<HighnoteErrorCode[]> => {
  const result = await api.get<HighnoteErrorCodesPayload>(
    '/admin/highnote/error_codes'
  )
  return result.data.items
}
